import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

// Vendors Components
import { CardHeader, Tooltip, IconButton } from '@material-ui/core';

import { Skeleton } from '@material-ui/lab';
import { Alert } from 'reactstrap';

import { Edit as EditIcon } from '@material-ui/icons';

//  Themes Components

import Auxiliary from 'util/Auxiliary';
import Widget from 'components/Widget/index';
import AlertBox from 'components/AlertBox/index';
// Custom Components and Helpers


//  Actions
import { onAddMedicationForm } from 'redux/actions/MedicalActions';
import { getValuefromLookup } from 'util/helpers';

const FamilyHistory = (props) => {
	const dispatch = useDispatch();
	const { contact } = useSelector(({ contactStore }) => contactStore);
	const { medicalrecord } = useSelector(({ medRecordStore }) => medRecordStore);
	const { accConfig } = useSelector(({ uiConfigureStore }) => uiConfigureStore);

	// on Add History
	const onAddHistory = () => {
		dispatch(onAddMedicationForm('update', 'familyhistory'));
		// dispatch(onContactForm(contact, 'update'));
	};
	return (
		<Widget styleName="jr-card-full jr-card-tabs-right jr-card-profile">
			<CardHeader
				action={
					medicalrecord.id && (
						<Tooltip title="Update About Info ">
							<IconButton
								aria-label="Add"
								onClick={() => onAddHistory()}
								variant="contained"
								color="primary"
							>
								<EditIcon />
							</IconButton>
						</Tooltip>
					)
				}
				title={'Family History'}
			/>
			<div className="jr-tabs-content jr-task-list">

				{!medicalrecord.familyHistory && (
					<AlertBox infotype="danger" message="No History Found." onClick={onAddHistory} />
				)}

				<div className="row">
					{medicalrecord.familyHistory &&
						medicalrecord.familyHistory.map((value, index) => {
							return (
								// <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" key={index}>
								<div className="col-12" key={index}>
									<Auxiliary>
										<div className="media flex-nowrap mt-3 mt-lg-4 mb-2">
											<div className="mr-3">
												{value.current && (
													<i className={`zmdi zmdi-check-circle jr-fs-xlxl text-red`} />
												)}
												{!value.current && (
													<i className={`zmdi zmdi-circle-o jr-fs-xlxl text-green`} />
												)}
											</div>
											<div className="media-body">
												<h6 className="mb-1 text-grey">
													{getValuefromLookup(accConfig.medicalHistory, value.name)}{' '}
												</h6>
												{getValuefromLookup(accConfig.familyRelations, value.relative)}
												<p>{value.note}</p>
											</div>
										</div>
									</Auxiliary>
								</div>
							);
						})}
				</div>
			</div>
		</Widget>
	);
};
export default FamilyHistory;
